const enlaceSiguiente = document.getElementById('siguiente1');
const informacionClientes = document.getElementById('datos-terceras-empresas')

enlaceSiguiente.addEventListener('click', function() {
  informacionClientes.innerHTML = mensajeSinClientes
});

window.openSectoresActividad = function () {
  document.querySelector('#sectores-actividad').open()
}

window.openClientes = function () {
  const formSimuladorData = getDataFormSimulacion()
  getClientesFormSimulacion(formSimuladorData)
  document.querySelector('#terceras-empresas').open()
}

function getDataFormSimulacion () {
  const formSimulacion = document.querySelector(nombre_del_formulario);
  const formDataSimulacion = new FormData(formSimulacion);

  const arrayParamsformSimulacions = Array.from(formDataSimulacion.entries()).filter(([name, value]) => {
    return value && value.trim() !== '' && name.startsWith('captador_simulacion')
  }).map(([name, value]) => {
    let newParamName = name.replace('captador_simulacion[', '').replace(']', '');
    let newParamValue = value.replace(/(\d)[.,](\d)/g, '$1$2');
    return { name: newParamName, value: newParamValue }
  });

  let preguntas_de_la_simulacion = document.getElementsByClassName("rnk-Wizard")?.item(0)?.path?.join()

  const arrayParamsValueSimulacion = arrayParamsformSimulacions.reduce(function(obj, item) {
    if(item.name !== 'referer_url') {
      obj[item.name] = item.value;
    }
    return obj;
  }, {});
  return { respuestas: arrayParamsValueSimulacion, preguntas_de_la_simulacion: preguntas_de_la_simulacion }
}

function getClientesFormSimulacion (data) {
  const checkAllOptions = document.querySelector('input[type=checkbox][id=captador_simulacion_marcar_todas_las_opciones]')
  let checkedValues = checkAllOptions.checked === true ? 'checked' : ''

  fetch(url_obtener_clientes, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
   },
    body: JSON.stringify(data),
 })
  .then((response) => response.json())
  .then((data) => {
    let html = ''
    if(data.length > 0 && (informacionClientes.textContent.trim() === mensajeSinClientes || checkedValues === 'checked')) {
      html = '<div>';
      data.forEach(item => {
        html += `<div><small><label for='captador_simulacion_cliente_${item.id}'>`;
        html += `<input label='${item.id}' type='checkbox' name='captador_simulacion[clientes][]' value='[${item.id},${item.partner_id}]' id='captador_simulacion_clientes_${item.id}' style='display: inline; width: 15px; height: 15px; vertical-align: text-bottom; margin-right: 0.5em' ${checkedValues}><span>${item.html}</span></label></small></div>`;
      })
      html = html + '</div>';
      informacionClientes.innerHTML = html
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

const telefonoConAceptacionLayer = document.querySelector('multistep-step[position="telefono"][view="telefono_con_aceptaciones"]')

const observer = new MutationObserver(mutations => {
  let actionPerformed = false
  mutations.forEach(mutation => {
    const computedStyle = getComputedStyle(telefonoConAceptacionLayer)
    const displayValue = computedStyle.getPropertyValue('display')
    if (displayValue === 'grid' && !actionPerformed) {
      const formSimuladorData = getDataFormSimulacion()
      getClientesFormSimulacion(formSimuladorData)
      actionPerformed = true
    }
  })
})

if (telefonoConAceptacionLayer) {
  observer.observe(telefonoConAceptacionLayer, { attributes: true })
}
